<template>
	<main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
		<router-view />
	</main>
</template>

<script>
export default {
	name: 'LayoutFull',
}
</script>

<style></style>
